/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuDto } from '../../models/menu-dto';

export interface EmailSend$Json$Params {
}

export function emailSend$Json(http: HttpClient, rootUrl: string, params?: EmailSend$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuDto>> {
  const rb = new RequestBuilder(rootUrl, emailSend$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuDto>;
    })
  );
}

emailSend$Json.PATH = '/api/Email/send-free-offer';
